import { Component, OnInit, Input } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-my-heading-dialoge',
  templateUrl: './my-heading-dialoge.component.html',
  styleUrls: ['./my-heading-dialoge.component.scss']
})
export class MyHeadingDialogeComponent implements OnInit {  
  
  @Input() heading:string ="";

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

}
